export default class IonMode {
    /**
     * @type {string|null}
     */
    #name;

    /**
     * @param {string|null} name
     */
    constructor(name) {
        if (typeof name === "string" && name.length !== 3)
            throw new Error(`IonMode name must null or strictly 3 characters long, but is: ${name}`);
        this.#name = name;
    }

    /** @returns {string|null} */
    get uiName() {
        return IonMode.#getUiName(this.#name);
    }

    /** @returns {string|null} */
    get name() {
        return this.#name;
    }

    /** @returns {boolean} */
    isPositive() {
        return this.#name.endsWith("P");
    }

    isElectronImpact() {
        return this.#name.startsWith("EI");
    }

    /**
     * @param {string|null} name
     * @returns {string|null}
     */
    static #getUiName(name) {
        if (name == null)
            return null;
        const ionSource = name.substring(0, 2);
        const polaritySign = name.endsWith("P") ? "+" : "-";
        return ionSource + polaritySign;
    }
}